export interface ILtToolbarOptions {
	title: String,
	lhsActions?: IToolbarAction[];
	rhsActions?: IToolbarAction[];
	onClose: () => void;
	cssClasses: object|string;
	showClose: boolean;
}

export class LtToolbar  implements ng.IDirective {
	restrict = 'E'; //attribute or element
	transclude = true;
	replace = true;
	elementClass = 'lt-toolbar';
	templateUrl = '/_resources/app-page/javascript/public/partials/toolbar.html';
	scope = {
		ltLhsActions: '=',
		ltTitle: '=',
		ltRhsActions: '=',
		ltShowClose: '=',
		ltOnClose: '&',
		cssClasses: '&ltCssClasses'
	};

	constructor() {
		this.link = ($scope: ng.IScope, element: ng.IAugmentedJQuery,
					 attrs: ng.IAttributes) => {

		};
	}

	link: ($scope: ng.IScope, elem: ng.IAugmentedJQuery,
		   attrs: ng.IAttributes) => void = null;

	static factory(): ng.IDirectiveFactory {
		const directive = () => new LtToolbar();
		directive.$inject = [];
		return directive;
	}
}

export interface IToolbarAction {
	title: string;
	icon: string;
	showTitle?: boolean;
	onClick: () => void;
}